/*
 * controllers/golfController.js
 * Golf Controller
 */

define('app/controllers/retailController',[
    'app/ControllerClass',
    'app/models/retailModel',
    'app/views/retailView'], function (ControllerClass, RetailModel, RetailView) {
        return window.app.controllers.retailController = $.extend({}, ControllerClass, {
            app: app,
            module: 'retail',
            actions: {
                'show': ['retailSelected'],
                'purchaseGC': ['giftCertificatePurchase']
            },
            init: function () {
                console.log('initializing retail controller');
                app.data.messages = app.data.messages || [];
                this._init.call(this);
            },

            retailSelected: function (categoryId, itemId) {
                $.when(app.models.retailModel.getData('giftCertificates', {}))
                    .done(function (r_gc) {
                        if (r_gc.GiftCertificate.length > 0 || r_gc.PackageCertificates.length > 0 || r_gc.Wrappings.length > 0 || r_gc.Shippings.length > 0) {
                            var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                            var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
                            // Dynamic restriction tryingToBook_module
                            app.commonViewHelper.eval_ttb({module:"giftCertificates", vipLevel: vipLevels, membershipId:membershipIds});
                            app.views.retailView.event.fire('requestGCSelection', [r_gc.GiftCertificate, r_gc.PackageCertificates, r_gc.Wrappings, r_gc.Shippings, categoryId, itemId]);
                        } else {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.general.err.defaultErr,
                                message: r_gc.Result ? "(" + r_gc.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('', '', [])
                        }
                    })
                    .fail(function (r_gc) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.general.err.defaultErr,
                            message: r_gc.Result ? "(" + r_gc.Result.Text + ")" : ""
                        });
                        app.dispatcher.replace('', '', [])
                    });
            },

            giftCertificatePurchase: function (itemId, toName, message, method, layout, email, address, address2, city, state, country, zipcode, express, wrappingid, shippingid) {
                if (itemId == "arrayMode") {
                    var data = toName;
                    var purchaseGCParameters = {
                        'CustomerId': app.data.CustomerId || app.data.DefaultCustomerId,
                        'ItemId': '',
                        'IssueToName': '',
                        'Message': '',
                        'Method': data.method,
                        'Layout': '',
                        'EmailAddress': '',
                        'MailToAddress:type=HOME.Address1': decodeURIComponent(data.address),
                        'MailToAddress:type=HOME.Address2': decodeURIComponent(data.address2),
                        'MailToAddress:type=HOME.City': decodeURIComponent(data.city),
                        'MailToAddress:type=HOME.StateProv': decodeURIComponent(data.state),
                        'MailToAddress:type=HOME.Country': decodeURIComponent(data.country),
                        'MailToAddress:type=HOME.PostCode': decodeURIComponent(data.zipcode),
                        'ExpressShipping': data.express == 'true' ? 'true' : 'false'
                    };
                    if (data.wrappingid) { purchaseGCParameters.WrappingId = data.wrappingid }
                    if (data.shippingid) { purchaseGCParameters.ShippingId = data.shippingid }

                    _.each(data.packItems, function (pkgItem, i) {
                        purchaseGCParameters["PackageCertificate:PackageId=" + data.itemId + ".PackageItem[" + i + "]:Id=" + pkgItem.PackageItemId + ".EmailAddress"] = pkgItem.EmailAddress
                        purchaseGCParameters["PackageCertificate:PackageId=" + data.itemId + ".PackageItem[" + i + "]:Id=" + pkgItem.PackageItemId + ".IssueToName"] = pkgItem.IssueToName
                        purchaseGCParameters["PackageCertificate:PackageId=" + data.itemId + ".PackageItem[" + i + "]:Id=" + pkgItem.PackageItemId + ".Layout"] = pkgItem.Layout
                        purchaseGCParameters["PackageCertificate:PackageId=" + data.itemId + ".PackageItem[" + i + "]:Id=" + pkgItem.PackageItemId + ".Message"] = pkgItem.Message
                    });
                } else {
                    if (typeof toName == 'undefined' || typeof method == 'undefined' || (method=="E" && typeof email == 'undefined')|| (method=="S" && typeof address == 'undefined')) {
                        app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.giftCertificate.failedPurchase,
                                message: "" //r_fb.Result.Text
                            });
                        app.dispatcher.replace('giftCertificates', 'show', ['', itemId || '']);
                        return
                    }
                    var purchaseGCParameters = {
                        'CustomerId': app.data.CustomerId || app.data.DefaultCustomerId,
                        'ItemId': itemId,
                        'IssueToName': toName,
                        'Message': message,
                        'Method': method,
                        'Layout': layout,
                        'EmailAddress': email,
                        'MailToAddress:type=HOME.Address1': address,
                        'MailToAddress:type=HOME.Address2': address2,
                        'MailToAddress:type=HOME.City': city,
                        'MailToAddress:type=HOME.StateProv': state,
                        'MailToAddress:type=HOME.Country': country,
                        'MailToAddress:type=HOME.PostCode': zipcode,
                        'ExpressShipping': express == 'true' ? 'true' : 'false'
                    };
                    if (wrappingid) { purchaseGCParameters.WrappingId = wrappingid }
                    if (shippingid) { purchaseGCParameters.ShippingId = shippingid }
                }
                $.when(app.models.retailModel.getData('purchaseGC', purchaseGCParameters))
                    .done(function (r_pgc) {
                        if (r_pgc.CertificateId) {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-success', actions: [],
                                title: app.localization.giftCertificate.successfulPurchase,
                                message: _.uniq([app.localization.giftCertificate.customerCustomTextHeader, app.localization.giftCertificate.customerCustomTextFooter]).join("<br/><br/>")
                            });
                            //app.models.systemModel.getData('folioBalance', {}).always(function () {
                            app.dispatcher.replace('summary', 'show', []);
                            //});
                        } else {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.giftCertificate.failedPurchase,
                                message: "" //r_fb.Result.Text
                            });
                            app.views.retailView.event.fire('updateMessages', []);
                        }
                    })
                    .fail(function (r_pgc) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.giftCertificate.failedPurchase,
                            message: app.localization.general.err.serverError //r_fb.Result.Text
                        });
                        app.views.retailView.event.fire('updateMessages', []);
                    });
            }
        })
    });

